import { Box } from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';
import { RT, createRetentionTheme } from './retentionTheme';

// Scopes the retention look to /student-journey/* only; the rest of the portal keeps its theme.
export default function RetentionThemeProvider({ children }) {
  return (
    <ThemeProvider theme={createRetentionTheme}>
      <Box sx={{ color: RT.ink }}>{children}</Box>
    </ThemeProvider>
  );
}
